import useMediaQuery from '../utils/useMediaQuery';

/**
 * The redesigned event + club surfaces switch layout at the app's desktop cut (lg = 1024px):
 * below it the checkout rail becomes a bottom sheet and the tab bar becomes a scrolling strip.
 */
export default function useIsMobile() {
  return useMediaQuery('(max-width: 1023px)');
}
